import { render } from "./BoardCell.vue?vue&type=template&id=5de84eb8&scoped=true"
import script from "./BoardCell.vue?vue&type=script&lang=js"
export * from "./BoardCell.vue?vue&type=script&lang=js"

import "./BoardCell.vue?vue&type=style&index=0&id=5de84eb8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de84eb8"]])

export default __exports__